<template>
  <!-- 文创 -->
  <div class="cultural-container w-100">
    <!-- 列表头部 -->
    <div class="com-list-header">
      <el-form class="com-search-box" :model="form" ref="form">
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item>
              <el-input v-model="form.title" placeholder="请输入"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="6">
            <el-form-item>
              <el-select v-model="form.type" placeholder="请选择类型">
                <el-option v-for="item in culturalTypeList" :key="item.dictCode" :label="item.dictName"
                  :value="item.dictCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

        </el-row>
      </el-form>

      <div class="com-head-search-btns" style="bottom: 30px;top: auto">
        <el-button type="primary" @click="getTableList">查询</el-button>
        <el-button @click="resetForm('form')">重置</el-button>
      </div>
    </div>

    <!-- 列表内容 -->
    <div class="com-list-content">
      <div class="button">
        <el-row>
          <el-button class="el-primary-border" round @click="handleAdd('add')">
            <svg-icon icon-class="add" />&nbsp;添加文创
          </el-button>
        </el-row>
      </div>
      <!-- 表格 -->
      <div class="table mt-20">
        <el-table ref="multipleTable" v-loading="listLoading" stripe :data="tableData">
          <el-table-column label="序号" width="50">
            <template slot-scope="scope">{{ scope.$index+1 }}</template>
          </el-table-column>
          <el-table-column prop="title" label="产品名称" min-width="20%" show-overflow-tooltip></el-table-column>
          <el-table-column prop="ext1" label="产品规格" min-width="13%"></el-table-column>
          <el-table-column prop="typeId" label="产品类别" min-width="8%">
            <template slot-scope="scope">{{ handleTypeId(scope.row.typeId) }}</template>
          </el-table-column>
          <el-table-column prop="price" label="产品价格" min-width="8%"></el-table-column>
          <el-table-column prop="createTime" label="发布时间" min-width="8%">
            <template slot-scope="scope">
              <span>{{$common.formatDateString(scope.row.createTime, 'yyyy-MM-dd')}}</span>
            </template>
          </el-table-column>
          <!-- 操作 -->
          <el-table-column fixed="right" label="操作" min-width="20%">
            <template slot-scope="scope">
              <a class="m-btn mr-10" @click="handleView(scope.row)">详情</a>
              <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a>
              <a class="m-btn mr-10 m-danger" @click="handleDelete(scope.row)">删除</a>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container paging">
          <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total" background
            layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
            @current-change="handleCurrentChange" />
        </div>
      </div>
    </div>

    <!-- 新增 -->
    <div>
      <el-dialog :title="operation == 'add' ? '新增文创': operation == 'edit' ? '编辑文创':'查看文创'" @close="onCancel"
        :close-on-click-modal="false" :visible.sync="dialogVisible" :width="'800px'">
        <el-form ref="addForm" class="g-form-grid" :model="addForm" :rules="rules" label-width="80px">
          <el-form-item class="mb-30" label="文创名称" prop="title">
            <el-input v-model="addForm.title" :disabled="operation == 'view'" placeholder="请输入文创名称" />
          </el-form-item>

          <el-form-item class="mb-30" label="文创类别" prop="typeId">
            <el-select v-model="addForm.typeId" :disabled="operation == 'view'" placeholder="请选择文创类别">
              <el-option v-for="item in culturalTypeList" :key="item.dictCode" :label="item.dictName"
                :value="item.dictCode">
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item class="mb-30" label="文创规格" prop="ext1">
            <el-input v-model="addForm.ext1" :disabled="operation == 'view'" placeholder="请输入文创规格" />
          </el-form-item>

          <!-- <el-form-item class="mb-30"  label="素材来源"  prop="ext2">
            <el-input v-model="addForm.ext2" :disabled="operation == 'view'" placeholder="请输入素材来源" />
          </el-form-item> -->

          <el-form-item class="mb-30" label="文创价格" prop="price">
            <el-input v-model="addForm.price" :disabled="operation == 'view'" placeholder="请输入文创价格" />
          </el-form-item>

          <!-- <el-form-item class="mb-30" prop="ext3">
            <el-input v-model="addForm.ext3" :disabled="operation == 'view'" placeholder="请输入购买链接" />
          </el-form-item> -->

          <el-form-item class="mb-30" label="产品简介" prop="subject">
            <el-input type="textarea" v-model="addForm.subject" :disabled="operation == 'view'" placeholder="请输入产品简介" />
          </el-form-item>

          <el-form-item class="avatar-uploader-form" label="文创封面" prop="attId">
            <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="operation == 'view'" accept="image/*" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload">
              <img v-if="imgUrl" style="height:120px;width: 100%;;object-fit:contain;" :src="imgUrl" class="avatar">
              <div v-else>
                <i class="el-icon-plus avatar-uploader-icon"></i>
                <div class="el-upload__text">上传文创封面</div>
              </div>
            </el-upload>
            <!-- <div class="uploader-form" @click="uploadPicture()">
              <img v-if="imgUrl" :src="imgUrl" alt="">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div> -->

            <div class="tip-img">建议图片大小：1600 * 900</div>
          </el-form-item>
        </el-form>
        <div class="dialog-footer tr mt-30" v-if="operation !== 'view'">
          <el-button @click="onCancel">取 消</el-button>
          <el-button type="primary" @click="onSubmit">确 定</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleAvatarSuccess">
    </cropper-image>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CropperImage from "@cmp/cropper";

export default {
  computed: {
    ...mapGetters(['imageTypes']),
  },
  components: { CropperImage },
  data() {
    const validateFile = (rule, value, callback) => {
      if (!this.addForm.attId) {
        callback(new Error('文创封面不能为空'))
      } else {
        callback()
      }
    }
    return {
      form: {
        title: '',
      },
      operation: 'add',
      addForm: {},
      rules: {
        title: [{ required: true, message: '文创名称不能为空', trigger: 'blur' }],
        typeId: [{ required: true, message: '文创类别不能为空', trigger: 'blur' }],
        ext1: [{ required: true, message: '文创规格不能为空', trigger: 'blur' }],
        price: [{ required: true, message: '文创价格不能为空', trigger: 'blur' }],
        attId: [{ required: true, validator: validateFile, trigger: 'blur' }],
      },
      configData: {
        tableName: 'collect'
      },
      imgUrl: "",
      listLoading: true,
      listQuery: {
        currentPage: 1,
        size: 10
      },
      total: 0,
      culturalTypeList: [],
      tableData: [],
      dialogVisible: false
    }
  },
  methods: {
    // 项目列表
    getData() {
      this.listLoading = true
      this.tableData = []
      this.$api.applet.getCulturalcreativeList({
        ...this.form,
        ...this.listQuery
      }).then(res => {
        this.listLoading = false
        if (res.success) {
          if (res.result && res.result.records) {
            this.tableData = res.result.records
            this.total = res.result.total
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    //封面设置
    uploadPicture() {
      if (this.operation == "view") {
        return
      }
      let option = {
        cropWidth: "315", cropHeight: "352", imgUrl: this.imgUrl
      }
      this.$refs.cropperRef.initCropper(option)
    },

    getDicData() {
      this.$http
        .get('/collectDict/getSelectDataByKey', { key: 'cc_type' })
        .then(res => {
          if (res.success) {
            var result = res.result
            this.culturalTypeList = result
          } else {
            this.$message.error(res.message)
          }
        })
    },

    handleTypeId(typeId) {
      let arr = this.culturalTypeList.filter(item => {
        return item.dictCode == typeId
      })
      if (arr && arr.length > 0) {
        return arr[0].dictName
      }

      return null
    },

    // 重置查询
    resetForm() {
      this.form = {
        title: '',
      }
      this.listQuery.currentPage = 1
      this.getData()
    },

    // 查询
    getTableList() {
      this.listQuery.currentPage = 1
      this.getData()
    },

    handleView(obj) {
      this.operation = "view"
      this.$api.applet.getCulturalcreativeDetail({ id: obj.id }).then(res => {
        if (res.success) {
          if (res && res.result) {
            this.dialogVisible = true
            this.addForm = res.result
            if (res.result.attId) {
              this.imgUrl = res.result.attId
            }

          }
        }
      })
    },

    // 新增
    handleAdd() {
      this.operation = "add"
      this.dialogVisible = true
    },

    handleEdit(obj) {
      this.operation = "edit"
      this.dialogVisible = true
      this.addForm = JSON.parse(JSON.stringify(obj))
      if (obj.attId) {
        this.imgUrl = `/singleMuseum/attach/getFile?fileId=${obj.attId}`
      }
    },

    // 删除
    handleDelete(obj) {
      this.$common.confirm(
        {
          title: `是否确认删除？`,
          className: 'cus-confirm-375'
        }, () => {
          this.$api.applet.delCulturalcreative({ id: obj.id }).then(res => {
            if (res.success) {
              this.$message.success('删除成功')
              this.getData()
            } else {
              this.$message.error(res.message)
            }
          })
        }
      )
    },

    // 表格分页
    handleSizeChange(val) {
      this.listQuery.size = val
      this.getData()
    },
    // 点击序号
    handleCurrentChange(val) {
      this.listQuery.currentPage = val
      this.getData()
    },

    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      if (!isLt2M) {
        this.$message({
          message: '上传文件大小不能超过 2MB!',
          type: 'warning'
        })
        return
      }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return
      }
    },

    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.attId = res.result.attId
        if (this.addForm.attId) {
          this.$refs['addForm'].clearValidate(['attId'])
        }
      } else {
        this.$message.error(res.message)
      }
    },


    onSubmit() {
      const self = this
      console.log(this.addForm)
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          let url = "addCulturalcreative"
          if (this.addForm.id) {
            url = "updateCulturalcreative"
          } else {
            // this.addForm.creater = this.$store.state.user.userid
            // this.addForm.updater = this.$store.state.user.userid
            // this.addForm.updateTime = new Date().getTime()
            // this.addForm.status = "0"

          }
          this.$api.applet[url](this.addForm).then(res => {
            if (res.success) {
              this.$message.success({
                message: this.addForm.id ? '文创修改成功' : '新增文创成功',
                duration: 500,
                onClose() {
                  self.dialogVisible = false
                  self.addForm = {}
                  self.imgUrl = ""
                  self.getData()
                }
              })
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          return false;
        }
      });
    },

    onCancel() {
      this.dialogVisible = false
      this.addForm = {}
      this.imgUrl = ""
      this.$refs["addForm"].clearValidate()
    },

    keydown(event) {
      if (event.keyCode == '13') {
        this.getTableList()
      }
    },

  },
  created() {
    this.getData()
    this.getDicData()

    window.addEventListener('keyup', this.keydown)

  }
}
</script>

<style lang="scss" scoped>
.cultural-container {
  /deep/ .el-form-item {
    .el-form-item__content {
      .el-date-editor,
      .el-select {
        width: 100%;
      }
    }

    &.avatar-uploader-form {
      .tip-img {
        left: 0;
      }
      .avatar-uploader {
        width: 50%;
        border: 1px dashed #8c939d;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .el-upload {
          width: 100%;
        }

        .el-icon-plus {
          font-size: 20px;
        }

        .el-upload__text {
          line-height: 1;
        }
      }
    }
  }
}
</style>